var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C6.41775 16 4.87103 15.5308 3.55544 14.6518C2.23984 13.7727 1.21446 12.5233 0.608964 11.0615C0.00346267 9.59966 -0.154964 7.99113 0.153718 6.43928C0.4624 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.4624 6.43928 0.153718C7.99113 -0.154964 9.59966 0.00346269 11.0615 0.608964C12.5233 1.21446 13.7727 2.23985 14.6518 3.55544C15.5308 4.87103 16 6.41775 16 8H13.76C13.76 6.86078 13.4222 5.74714 12.7893 4.79992C12.1563 3.85269 11.2568 3.11441 10.2043 2.67845C9.15175 2.24249 7.99361 2.12843 6.87628 2.35068C5.75895 2.57293 4.73262 3.12151 3.92706 3.92706C3.12151 4.73262 2.57293 5.75895 2.35068 6.87628C2.12843 7.99361 2.24249 9.15175 2.67845 10.2043C3.11441 11.2568 3.85269 12.1563 4.79992 12.7893C5.74714 13.4222 6.86078 13.76 8 13.76V16Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyIndicator);
export default __webpack_public_path__ + "static/media/Grey Indicator.1ab655ed2c27aa7e866b6780fd3d7384.svg";
export { ForwardRef as ReactComponent };